/**
 *  @file 定义全局方法
 *  @author Dmw
 *  @date 2017-5-24 14:24:32
 *  @description 全局方法统一集中于此，便于查看，使用 Vue.js 开发时全局方法封装入 Vue 的原型中
 */
import Vue from "vue";
// 时间格式化过滤器
Vue.filter("dateTime", (now) => {
  if (now === "") return "";
  now = new Date(now);
  return `
          ${now.getFullYear()}-${
    now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1
  }-${now.getDate() < 10 ? "0" + now.getDate() : now.getDate()}
          ${now.getHours() < 10 ? "0" + now.getHours() : now.getHours()}:
          ${now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes()}:
          ${now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds()}
          `;
});
// 时间格式化过滤器 返回 yyyy年mm月dd日
Vue.filter("yearTime", (now) => {
  if (now === "") return "";
  return `${now.getFullYear()}年${
    now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1
  }月${now.getDate() < 10 ? "0" + now.getDate() : now.getDate()}日`;
});
// 时间格式化过滤器 返回 yyyy-mm-dd
Vue.filter("yearsTime", (now) => {
  if (now === "") return "";
  now = new Date(now);
  return `${now.getFullYear()}-${
    now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1
  }-${now.getDate() < 10 ? "0" + now.getDate() : now.getDate()}`;
});
